import LocationHelper from '../../helpers/location_helper';

const Logo = () => {
  return `<svg
       xmlns:dc="http://purl.org/dc/elements/1.1/"
       xmlns:cc="http://creativecommons.org/ns#"
       xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
       xmlns:svg="http://www.w3.org/2000/svg"
      xmlns="http://www.w3.org/2000/svg"
      id="svg41"
      viewBox="0 0 5541.6125 499.64487"
      height="499.64487"
      width="5541.6128"
      version="1.1"
    >
      <defs id="defs45" />
      <g id="g39" transform="matrix(10.169492,0,0,10.169492,90.00001,-92.397146)">
        <defs id="SvgjsDefs1133" />
        <g
          style="fill:#ffffff"
          transform="matrix(0.84269663,0,0,0.84269663,-13.484832,-8.4836631)"
          featureKey="symbolFeature-0"
          id="SvgjsG1134"
        >
          <path
            id="path3"
            d="m 7,47 c -0.829,0 -1.5,0.671 -1.5,1.5 v 3 c 0,0.829 0.671,1.5 1.5,1.5 0.829,0 1.5,-0.671 1.5,-1.5 v -3 C 8.5,47.671 7.829,47 7,47 Z"
          />
          <path
            id="path5"
            d="m 12.733,41.603 c -0.829,0 -1.5,0.671 -1.5,1.5 v 13.795 c 0,0.829 0.671,1.5 1.5,1.5 0.829,0 1.5,-0.671 1.5,-1.5 V 43.103 c 0,-0.829 -0.671,-1.5 -1.5,-1.5 z"
          />
          <path
            id="path7"
            d="m 18.467,44.667 c -0.829,0 -1.5,0.671 -1.5,1.5 v 7.667 c 0,0.829 0.671,1.5 1.5,1.5 0.829,0 1.5,-0.671 1.5,-1.5 v -7.667 c 0,-0.829 -0.672,-1.5 -1.5,-1.5 z"
          />
          <path
            id="path9"
            d="m 24.2,36.375 c -0.829,0 -1.5,0.671 -1.5,1.5 v 24.25 c 0,0.829 0.671,1.5 1.5,1.5 0.829,0 1.5,-0.671 1.5,-1.5 v -24.25 c 0,-0.829 -0.671,-1.5 -1.5,-1.5 z"
          />
          <path
            id="path11"
            d="m 29.933,28.833 c -0.829,0 -1.5,0.671 -1.5,1.5 v 39.333 c 0,0.829 0.671,1.5 1.5,1.5 0.829,0 1.5,-0.671 1.5,-1.5 V 30.333 c 0,-0.828 -0.671,-1.5 -1.5,-1.5 z"
          />
          <path
            id="path13"
            d="m 35.667,37.333 c -0.829,0 -1.5,0.671 -1.5,1.5 v 22.333 c 0,0.829 0.671,1.5 1.5,1.5 0.829,0 1.5,-0.671 1.5,-1.5 V 38.833 c 0,-0.828 -0.672,-1.5 -1.5,-1.5 z"
          />
          <path
            id="path15"
            d="m 41.534,29.835 c -0.87,-0.024 -1.505,0.662 -1.51,1.49 l -0.249,37.331 c -0.005,0.828 0.662,1.504 1.49,1.51 0.003,0 0.006,0 0.01,0 0.824,0 1.495,-0.665 1.5,-1.49 l 0.249,-37.331 c 0.006,-0.828 -0.661,-1.505 -1.49,-1.51 z"
          />
          <path
            id="path17"
            d="m 47.133,20.849 c -0.829,0 -1.5,0.671 -1.5,1.5 v 55.303 c 0,0.829 0.671,1.5 1.5,1.5 0.829,0 1.5,-0.671 1.5,-1.5 V 22.349 c 0,-0.829 -0.671,-1.5 -1.5,-1.5 z"
          />
          <path
            id="path19"
            d="m 52.867,27.25 c -0.829,0 -1.5,0.671 -1.5,1.5 v 42.5 c 0,0.829 0.671,1.5 1.5,1.5 0.829,0 1.5,-0.671 1.5,-1.5 v -42.5 c 0,-0.829 -0.672,-1.5 -1.5,-1.5 z"
          />
          <path
            id="path21"
            d="m 58.6,37.333 c -0.829,0 -1.5,0.671 -1.5,1.5 v 22.333 c 0,0.829 0.671,1.5 1.5,1.5 0.829,0 1.5,-0.671 1.5,-1.5 V 38.833 c 0,-0.828 -0.671,-1.5 -1.5,-1.5 z"
          />
          <path
            id="path23"
            d="m 64.333,31 c -0.829,0 -1.5,0.671 -1.5,1.5 v 35 c 0,0.829 0.671,1.5 1.5,1.5 0.829,0 1.5,-0.671 1.5,-1.5 v -35 c 0,-0.829 -0.671,-1.5 -1.5,-1.5 z"
          />
          <path
            id="path25"
            d="m 70.067,39.632 c -0.829,0 -1.5,0.671 -1.5,1.5 v 17.735 c 0,0.829 0.671,1.5 1.5,1.5 0.829,0 1.5,-0.671 1.5,-1.5 V 41.132 c 0,-0.828 -0.671,-1.5 -1.5,-1.5 z"
          />
          <path
            id="path27"
            d="m 75.8,43.5 c -0.829,0 -1.5,0.671 -1.5,1.5 v 10 c 0,0.829 0.671,1.5 1.5,1.5 0.829,0 1.5,-0.671 1.5,-1.5 V 45 c 0,-0.829 -0.672,-1.5 -1.5,-1.5 z"
          />
          <path
            id="path29"
            d="m 81.533,41.735 c -0.829,0 -1.5,0.671 -1.5,1.5 v 13.53 c 0,0.829 0.671,1.5 1.5,1.5 0.829,0 1.5,-0.671 1.5,-1.5 v -13.53 c 0,-0.829 -0.671,-1.5 -1.5,-1.5 z"
          />
          <path
            id="path31"
            d="m 87.267,45.99 c -0.829,0 -1.5,0.671 -1.5,1.5 v 5.021 c 0,0.829 0.671,1.5 1.5,1.5 0.829,0 1.5,-0.671 1.5,-1.5 V 47.49 c 0,-0.829 -0.672,-1.5 -1.5,-1.5 z"
          />
          <path
            id="path33"
            d="m 93,47.417 c -0.829,0 -1.5,0.671 -1.5,1.5 v 2.167 c 0,0.829 0.671,1.5 1.5,1.5 0.829,0 1.5,-0.671 1.5,-1.5 v -2.167 c 0,-0.829 -0.671,-1.5 -1.5,-1.5 z"
          />
        </g>
        <g
          style="fill:#ffffff"
          transform="matrix(0.88895697,0,0,0.88895697,102.76914,10.736458)"
          featureKey="nameFeature-0"
          id="SvgjsG1135"
        >
          <text x="-35" y="48" fill="white" font-size="5em" font-family="monospace">
            ${(LocationHelper.getEnvByDomain() || '').toUpperCase()}
          </text>
        </g>
      </g>
    </svg>`;
};

export default Logo;
